import { Component, Input } from '@angular/core';

@Component({
  selector: 'base-page-layout',
  templateUrl: './base-page-layout.component.html',
  host: {
    class: 'celerity-layout-content'
  }
})
export class BasePageLayoutComponent {
  @Input() title: string;
}
